<template>
  <div class="card">
    <div class="card-header d-flex">
      <h3 class="mb-0">Live {{isViewByComputer ? 'Computers' : 'Jobs'}}</h3>
<!--      <b-nav class="ml-auto p-1">-->
<!--        <b-button size="sm" @click="viewByComputers" :pressed="isViewByComputer" variant="outline-primary">Computers</b-button>-->
<!--        <b-button size="sm" @click="viewByJobs" :pressed="isViewByJob" variant="outline-primary">Jobs</b-button>-->
<!--      </b-nav>-->
    </div>
    <div class="card-body">
      <div v-if="loadComplete">
        <div v-if="viewBy === 'computers'">
          <!-- Tab: viewBy = computers -->
          <div v-if="machineIds.size > 0">
            <b-row class="m-3">
              <b-col v-for="(machId, index) in machineIds" :key="machId" class="col-xl-3 col-lg-6 col-md-12">
                <div>
                  <live-machine-card :machineId="machId" :machineSortIndex="index"/>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else class="text-center p-3">
            There are no live computers in this project.
          </div>
        </div>
        <div v-else>
          <!-- Tab: viewBy = jobs -->
          <div v-if="jobIds.length > 0">
            <b-row class="m-3">
              <b-col v-for="(jobId, index) in jobIds" :key="jobId" class="col-xl-3 col-lg-6 col-md-12">
                <div>
<!--                  <div>JOB ID: {{jobId}}</div>-->
<!--                  <div>JOB IDS:" {{jobIds}}</div>-->
                  <live-job-card :jobId="jobId"/>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else class="text-center p-3">
            There are no live jobs in this project.
          </div>
        </div>
      </div>
      <div v-else class="text-center p-3">
        <b-spinner size="sm"></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import LiveMachineCard from '#/ui/Components/Live/LiveMachineCard.vue';
import LiveJobCard from '#/ui/Components/Live/LiveJobCard.vue';

const VIEW_BY_COMPUTER_PROP = 'computers';
const VIEW_BY_JOB_PROP = 'jobs';

export default {
  components: {
    LiveMachineCard, // Machine view not currently implemented
    LiveJobCard,
  },
  props: {
    // tabs for nav / viewBy = [computers, jobs] are controlled by this prop.
    // note that this prop is set in the routes file itself based upon a query param, else it defaults if not set.
    viewBy: {
      type: String,
      required: false,
      default: VIEW_BY_JOB_PROP,
    },
  },
  created() {
    // this.$store.dispatch('live/beginProjectStream');
  },
  beforeDestroy() {
    // TODO: when to kill loop
    // this.$store.commit('live/killRunLoop');
  },
  computed: {
    ...mapState('live', [
      'snapshots',
    ]),
    ...mapGetters('live', [
      'loadComplete',
      'machineIds',
      'jobIds',
      // 'snapshotMap',
    ]),
    isViewByComputer() {
      return this.viewBy === VIEW_BY_COMPUTER_PROP;
    },
    isViewByJob() {
      return this.viewBy === VIEW_BY_JOB_PROP;
    },
  },
  methods: {
    viewByComputers() {
      if (this.isViewByComputer) {
        return;
      }
      this.$router.push({ path: this.$route.path, query: { viewBy: VIEW_BY_COMPUTER_PROP, project: this.$route.query.project } });
    },
    viewByJobs() {
      if (this.isViewByJob) {
        return;
      }
      this.$router.push({ path: this.$route.path, query: { viewBy: VIEW_BY_JOB_PROP, project: this.$route.query.project } });
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
